/// Na tela larga, o painel lateral cabe na janela desde a abertura da página: a altura fixa só
/// cabia depois que a rolagem o grudava no topo, e o rodapé com o total abria fora da vista.
export function fitToViewport(node: HTMLElement, gap = 16): () => void {
  const wide = window.matchMedia?.('(min-width: 1024px)');
  const fit = () => {
    if (!wide?.matches) {
      node.style.maxHeight = '';
      return;
    }
    const top = Math.max(node.getBoundingClientRect().top, gap);
    // Com o topo muito baixo, um mínimo evita um painel espremido; a rolagem o traz para cima.
    node.style.maxHeight = `${Math.max(window.innerHeight - top - gap, 320)}px`;
  };
  fit();
  window.addEventListener('scroll', fit, { passive: true });
  window.addEventListener('resize', fit);
  return () => {
    window.removeEventListener('scroll', fit);
    window.removeEventListener('resize', fit);
    node.style.maxHeight = '';
  };
}
